import { Avatar } from "primereact/avatar";
import { Tooltip } from "primereact/tooltip";

export const InstitutionNameBodyTemplate = (rowData: any) => {
  return (
    <div className="flex align-items-center gap-2 w-full">
      <Tooltip target=".custom-target-icon" />
      <Avatar
        shape="circle"
        size="large"
        className="text-white bg-gray-400"
        image={`${
          rowData
            ? rowData?.imageFormat + "," + rowData?.imageBase64
            : undefined
        }`}
        label={
          rowData
            ? `${rowData.name ? rowData.name.charAt(0).toUpperCase() : ""}`
            : ""
        }
      />
      <span>{rowData.name}</span>
      <i
        data-pr-tooltip={
          rowData.activated || rowData.complete ? "Activa" : "Inactiva"
        }
        className={`custom-target-icon p-text-secondary pi ${
          rowData.activated || rowData.complete
            ? "true-icon pi-check-circle text-green-500"
            : "false-icon pi-times-circle text-red-500"
        }`}
      />
    </div>
  );
};
